import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  background: ${(props) => props.$backgroundColor || props.theme.colors.NEU_200};
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LogoWrapper = styled.div`
  max-width: 50%;
  height: auto;
  margin: 0;

  img {
    width: 100%;
    height: 100%;
    max-height: 100px;
    object-fit: contain;
    position: static;
  }
`;

const ImagePlaceholder = ({ $backgroundColor, ownerLogo }) => (
  <Wrapper $backgroundColor={$backgroundColor}>
    {ownerLogo && (
      <LogoWrapper>
        <img src={ownerLogo} alt={'logo from publisher'} loading='lazy' />
      </LogoWrapper>
    )}
  </Wrapper>
);

export default ImagePlaceholder;
